<template>
  <div class="childtrackingsystem-groupoverview">
      <div class="modalLoader" v-if="isLoading">
        <img src="../../assets/img/loading.gif" style="width: 80px; height: 80px;"/>
      </div>

      <div class="row align-items-center bg-white pt-4 pb-1">
          <div class="col-md-2 fw-bold">Observatielijsten</div>
          <div class="col-md-4">
              <select
                  class="form-select form-select-sm"
                  id="idList"
                  v-model="selectedList"
                  name="idList"
                  @change="getResults()"
              >
                  <option value="0" selected>Kies een observatielijst</option>
                  <option
                      v-for="list in observationLists"
                      :key="list.id"
                      :value="list.id"
                  >{{ list.titel }}
                  </option>
              </select>
          </div>
          <div class="col-md-2 fw-bold">Ontwikkelingsgebied</div>
          <div class="col-md-4">
              <select
                  class="form-select form-select-sm"
                  id="idCategory"
                  v-model="selectedCategory"
                  name="idCategory"
                  @change="getResults()"
              >
                  <option value="0" selected>Alle</option>
                  <option
                      v-for="category in categories"
                      :key="category.id"
                      :value="category.id"
                  >{{ category.name }}
                  </option>
              </select>
          </div>
      </div>
      <div class="row align-items-center bg-white py-1">
          <div class="col-md-2 fw-bold">Mentor</div>
          <div class="col-md-4">
              <select
                  class="form-select form-select-sm"
                  id="mentor"
                  v-model="selectedMentor"
                  name="mentor"
                  @change="getResults()"
              >
                  <option value="0" selected>Alle</option>
                  <option
                      v-for="mentor in mentors"
                      :key="mentor.id"
                      :value="mentor.id"
                  >{{ mentor.name }}
                  </option>
              </select>
          </div>
          <div class="col-md-2 fw-bold">Leeftijd</div>
          <div class="col-md-4">
              <select
                  class="form-select form-select-sm"
                  id="age"
                  v-model="selectedAge"
                  name="age"
                  @change="getResults()"
              >
                  <option value="0" selected>Alle</option>
                  <option
                      v-for="age in ages"
                      :key="age.id"
                      :value="age.id"
                  >{{ age.description }}
                  </option>
              </select>
          </div>
      </div>

    <div class="row bg-white pt-2 pb-2">
      <div class="col-md-12">
        <br>
      </div>
    </div>
    <div v-if="!isResults" class="row bg-white pt-5 pb-5">
      <div class="col-md-12 alert alert-danger">
        <span class="ps-2 pt-2 pb-2">Kies een observatielijst om het groepsoverzicht te zien</span>
      </div>
    </div>
    <div class="row bg-white"
         v-for="(result, rIdx) in results"
         :key="rIdx">
        <div class="col-12">
        <table style="width:100%; overflow: auto; border-collapse: inherit; border-spacing: 0 10px;"
               v-for="(category, cIdx) in result.categories"
               :key="cIdx">
          <tr class="preHeader">
            <td style="width: 800px;" @click="showContent(category.idCategory)">
                  <span :style="'color:' + category.color + ';padding-left:15px;'">
              {{ category.category }}
            </span>
            </td>
            <td v-for="(child, childIdx) in category.children" :key="childIdx" style="width:150px;vertical-align: top;">
              <span :title="child.full_name">{{ child.shortName }}</span> <br>
              ({{ child.ageChild }} mnd)
            </td>
          </tr>
          <tbody :id="'content-'+category.idCategory" class="d-none">
          <tr class="bg-white borderBottomShadow" v-for="(question, qIdx) in category.questions" :key="qIdx"
              style="border-bottom: 1pt solid #666;">
            <td class="borderBottomShadow" style="width: 800px;padding-left:15px;"><span v-if="question.subcategory"><b>{{question.subcategory}}:</b> </span>{{ question.question }}</td>
            <td class="borderBottomShadow"
                v-for="(answer, aIdx) in question.answers" :key="aIdx"
                style="width:150px;text-align: center;">
              <div
                  :style="'border-radius: 50%;width:25px;height:25px;background-color:' + answer.color + ';color:' + answer.color"
                  :title="answer.date"
              ></div>
            </td>
          </tr>
          </tbody>
          <tr style="height: 50px;">
            <td style="width: 800px;"><b>Gem. score</b></td>
            <td v-for="(child, childIdx) in category.children" :key="childIdx" style="width:150px;">
              {{ child.score }} / {{ child.totalScore }}
            </td>
          </tr>
        </table><br><br>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'childtrackingsystem-groupoverview',
  components: {},
  data() {
    return {
      isLoading: false,
      results: [],
      mentors: [],
      selectedMentor: null,
      ages: [],
      selectedAge: null,
      observationLists: [],
      selectedList: null,
      categories: [],
      selectedCategory: null,
      isResults: false
    }
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken
    },
    session() {
      return this.$store.getters.session
    },
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
    this.getResults()
  },
  methods: {
    getResults() {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      this.$request.post('/ChildTrackingSystem/groupOverview', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        idAge: this.selectedAge,
        idList: this.selectedList,
        idMentor: this.selectedMentor,
        idCategory: this.selectedCategory
      }).then((response) => {
        this.isLoading = false
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        this.results = response.results
        this.ages = response.ages
        this.observationLists = response.lists
        this.mentors = response.mentors
        this.categories = response.categories
        this.selectedMentor = response.idMentor
        this.selectedCategory = response.idCategory
        this.selectedList = response.idList
        this.selectedAge = response.idAge
        this.isResults = !!(this.selectedList && this.results.length > 0)
      })
    },
    showContent(idCategory) {
      let elem = document.getElementById("content-" + idCategory)
      if (elem.classList.contains('d-none')) {
        elem.classList.remove('d-none')
      } else {
        elem.classList.add('d-none')
      }
    }
  }
}
</script>
<style scoped>
label {
    margin: 0;
    font-weight: bolder;
}

.header {
  color: #445161;
  background-color: #f0f0f5;
}

.preHeader {
  color: #445161;
  background-color: #dedee7;
}

.borderBottomShadow {
  border-bottom: 1px #ddd solid;
}

</style>